module.exports = __webpack_public_path__ + "img/20200514_154545.c2d9da9a.jpg";